import { render, staticRenderFns } from "./DeleteFakeUser.vue?vue&type=template&id=aacb0662&scoped=true"
import script from "./DeleteFakeUser.vue?vue&type=script&lang=js"
export * from "./DeleteFakeUser.vue?vue&type=script&lang=js"
import style0 from "./DeleteFakeUser.vue?vue&type=style&index=0&id=aacb0662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacb0662",
  null
  
)

export default component.exports